var $ca7518a2d1866cd1$exports = {};
(function() {
    const tagsList = [
        ...document.querySelectorAll('.tags .tag')
    ];
    const navigateLink = ({ currentTarget: currentTarget, key: key, type: type })=>{
        if (type === 'click' || key === 'Enter') {
            const { dataset: dataset } = currentTarget;
            window.open(dataset.href, '_self');
        }
    };
    tagsList.forEach((tag)=>{
        tag.addEventListener('click', navigateLink);
        tag.addEventListener('keydown', navigateLink);
    });
})();


//# sourceMappingURL=case.6155d908.js.map
